export default __webpack_public_path__ + "static/media/Cabeçalho_3_moblie.49f20738.png";